/**
 * The transcript as the server wants it replayed (F-144) — pure, so the
 * panel's one piece of conversation logic is testable without React.
 */
import { AGENT_MAX_HISTORY_CHARS, AGENT_MAX_HISTORY_TURNS, type AgentHistoryTurn } from "@kola/shared";

import type { AgentPlanState, AgentTurn } from "./store.js";

/**
 * The transcript as the server wants it replayed: user turns with their file
 * names, assistant turns with what became of their plan — so the model knows
 * which of its suggestions actually landed. Errors are not part of the story.
 */
export function buildHistory(turns: readonly AgentTurn[]): AgentHistoryTurn[] {
  const out: AgentHistoryTurn[] = [];
  for (const turn of turns) {
    if (turn.error) continue;
    let text = turn.text;
    if (turn.role === "user" && turn.attachments !== undefined && turn.attachments.length > 0) {
      text += `\n[attached: ${turn.attachments.map((a) => a.name).join(", ")}]`;
    }
    if (turn.role === "assistant" && turn.plan !== undefined) {
      text += `\n[proposed plan: ${turn.plan.summary} — ${planStateWord(turn.planState)}]`;
    }
    text = text.trim();
    if (text.length === 0) continue;
    out.push({ role: turn.role, text: text.length > AGENT_MAX_HISTORY_CHARS ? text.slice(0, AGENT_MAX_HISTORY_CHARS) : text });
  }
  return out.slice(-AGENT_MAX_HISTORY_TURNS);
}

export function planStateWord(state: AgentPlanState | undefined): string {
  switch (state) {
    case "applied":
    case "reverting":
      return "the person applied it";
    case "reverted":
      return "the person applied it, then reverted it";
    case "discarded":
      return "the person discarded it";
    default:
      return "not applied yet";
  }
}

